module.exports = __webpack_public_path__ + "static/media/logo_locofolio.47bd767c.png";